


import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import "./SideBar.css";
import closeIcon from "../assets/icons/close.png";
import userIcon from "../assets/icons/man1.svg";

export default function Sidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const { user, loading, resetUserContext, isInactive } = useContext(AppContext);
  
  // RE-ADDED: This state is crucial for the CSS transition to work.
  const [visible, setVisible] = useState(false);

  // ... rest of useEffect stays the same ...
  useEffect(() => {
    if (isOpen) {
      // A tiny delay allows the component to mount before the 'open' class is added.
      const timer = setTimeout(() => setVisible(true), 10);
      return () => clearTimeout(timer);
    } else {
      setVisible(false);
    }
  }, [isOpen]);


  const allItems = [
    { icon: "home",     llabel: "Home",               path: "/home" },
    { icon: "hammer",   llabel: "My Bids",            path: "/bids" },
    { icon: "lock",     llabel: "MPIN",               path: "/set-new-pin" },
    { icon: "doc",      llabel: "Passbook",           path: "/passbook" },
    { icon: "chat",     llabel: "Chats",              href: `https://wa.me/${919306360393}` },
    { icon: "bank",     llabel: "Funds",              path: "/funds" },
    { icon: "bell",     llabel: "Notifications",      path: "/notifications" },
    { icon: "video",    llabel: "Videos",             path: "/videos" },
    { icon: "rules",    llabel: "Notice Board/Rules", path: "/rules" },
    { icon: "rates",    llabel: "Game Rates",         path: "/rates" },
    { icon: "chart",    llabel: "Charts",             path: "/charts" },
    { icon: "rules",    llabel: "Policy App",         path: "/privacy-policy" },
    { icon: "doc",      llabel: "Data Delete",        path: "/delete-account" },
    { icon: "doc",      llabel: "Terms & Conditions", path: "/terms-conditions" },
    { icon: "idea",     llabel: "Submit Idea",        path: "/submit-idea" },
    { icon: "settings", llabel: "Settings",           path: "/settings" },
    { icon: "share",    llabel: "Share Application",  path: "/share" },
    { icon: "logout",   llabel: "LOGOUT",             path: "/logout" },
  ];

  const visibleItems = isInactive
    ? allItems
        .map(item => item.llabel === "Passbook" ? { ...item, llabel: "Bid History" } : item)
        .filter(item => !["Funds", "Videos", "Notice Board/Rules", "Game Rates", "Charts"].includes(item.llabel))
    : (user?.accountStatus === true 
        ? allItems
        : allItems.filter(item =>
            ["Charts", "Policy App", "Data Delete", "Terms & Conditions", "LOGOUT"].includes(item.llabel)
          )
      );

  // In SideBar.jsx

const handleLogout = () => {
  // 1. Call the function to clear the context state and localStorage.
  resetUserContext();
  
  // 2. Navigate AFTER a very short delay.
  // This gives the browser a moment to fully process all the 
  // localStorage.removeItem() commands before the page changes.
  setTimeout(() => {
    navigate("/", { replace: true });
    onClose(); // It's also better to call onClose after the navigation
  }, 100); // 50 milliseconds is unnoticeable to the user but crucial for the browser.
};
  return (
    // The outer container should only render when isOpen is true
    // to prevent it from blocking content when closed.
    isOpen && (
      <div className="sidebar-container">
        <div
          className={`sidebar-overlay ${visible ? "open" : ""}`}
          onClick={onClose}
        />
        {/* The 'visible' state now controls the 'open' class for the transition */}
        <aside className={`sidebar ${visible ? "open" : ""}`}>
          <header className="sidebar-header">
            <div className="user-info">
              <img 
                src={user?.profilePicture || userIcon} 
                alt="User" 
                className="user-icon" 
              />
              <div className="user-details">
                <div className="username">{loading ? 'Loading...' : (user?.fullName || 'Guest')}</div>
                <div className="phone">{loading ? '...' : (user?.mobileNo || '')}</div>
              </div>
            </div>
            <button className="close-btn" onClick={onClose}>
              <img src={closeIcon} alt="×" />
            </button>
          </header>

          <ul className="sidebar-menu">
            {visibleItems.map(({ icon, llabel, path ,href}) => (
              <li
                key={llabel}
                onClick={() => {
                  if (llabel === "LOGOUT") {
                    handleLogout();
                  } else if (path) {
                    navigate(path);
                    onClose();
                  } else if (href) {
                    window.open(href, '_blank', 'noopener,noreferrer');
                    onClose();
                  }
                }}
              >
                <span className={`sidebar-icon icon-${icon}`} />
                <span className="llabel">{llabel}</span>
              </li>
            ))}
          </ul>
        </aside>
      </div>
    )
  );
}
